import React, { useState, useEffect } from 'react';
import { Table, ButtonPrimary, Input } from './styles';
import { useParams } from 'react-router-dom';
import './style.css';
import axios from 'axios';
import Swal from 'sweetalert2';

export const PesquisaEndereco = () => {
    const [enderecos, setEnderecos] = useState([]);
    const [enderecoInput, setEnderecoInput] = useState('');
    const { id, periodo } = useParams();
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        if (enderecoInput) {
            fetchEnderecos(enderecoInput);
        }
    }, [enderecoInput]);

    const groupByEndereco = (records) => {
        return records.reduce((acc, record) => {
            const { endereco } = record;
            if (!acc[endereco]) {
                acc[endereco] = {
                    endereco,
                    total_enderecos: record.total_enderecos,
                    produtos: []
                };
            }
            acc[endereco].produtos.push({
                ean: record.ean,
                nome_produto: record.nome_produto,
                total_produtos: record.total_produtos
            });
            return acc;
        }, {});
    };

    const fetchEnderecos = async (endereco) => {
        try {
            const response = await axios.get(`https://inventario.dracherie.com.br/api_cherie/componentes_qr_code/pesquisa_endereco.php?endereco=${endereco}&id_loja=${id}&id_periodo=${periodo}`);
            if (response.data && response.data.records.length > 0) {
                const groupedEnderecos = groupByEndereco(response.data.records);
                setEnderecos(Object.values(groupedEnderecos)); 
                setErrorMessage('');
            } else {
                setEnderecos([]);
                setErrorMessage('Nenhum endereço encontrado.');
            }
        } catch (error) {
            setErrorMessage('Erro ao buscar o endereço.');
        }
    };

    const handleExcluirEndereco = (endereco) => {
        Swal.fire({
            title: 'Tem certeza?',
            text: `Você está prestes a excluir o endereço "${endereco}". Isso será irreversível!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: 'green',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, excluir!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                deleteEndereco(endereco);
            }
        });
    };

    const deleteEndereco = async (endereco) => {
        try {
            const response = await axios.delete(`https://inventario.dracherie.com.br/api_cherie/componentes_qr_code/delete_endereco.php`, {
                data: {
                    endereco: endereco,
                    id_loja: id,
                    id_periodo: periodo
                }
            });
            if (response.status === 200) {
                setEnderecos(enderecos.filter(e => e.endereco !== endereco));
                Swal.fire('Excluído!', 'O endereço foi excluído com sucesso.', 'success');
            } else {
                Swal.fire('Erro!', 'Não foi possível excluir o endereço.', 'error');
            }
        } catch (error) {
            Swal.fire('Erro!', 'Ocorreu um erro ao tentar excluir o endereço.', 'error');
        }
    };

    return (
        <div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <Input
                    type="text"
                    value={enderecoInput}
                    onChange={(e) => setEnderecoInput(e.target.value)}
                    placeholder="Digite o endereço"
                />
                <ButtonPrimary onClick={() => fetchEnderecos(enderecoInput)}>Pesquisar</ButtonPrimary>
            </div>

            {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}

            {enderecos.length > 0 && (
                <div>
                    <Table>
                        <thead>
                            <tr>
                                <th>Endereço</th>
                                <th>EAN</th>
                                <th>Nome do Produto</th>
                                <th>Quantidade</th>
                                <th>Ação</th>
                            </tr>
                        </thead>
                        <tbody>
                            {enderecos.map((endereco) => (
                                endereco.produtos.map((produto, index) => (
                                    <tr key={`${endereco.endereco}-${index}`}>
                                        {index === 0 ? (
                                            <>
                                                <td rowSpan={endereco.produtos.length}>{endereco.endereco}</td>
                                            </>
                                        ) : null}
                                        <td>{produto.ean}</td>
                                        <td>{produto.nome_produto}</td>
                                        <td>{produto.total_produtos}</td>
                                        {index === 0 ? (
                                            <td rowSpan={endereco.produtos.length}>
                                                <ButtonPrimary onClick={() => handleExcluirEndereco(endereco.endereco)}>Excluir</ButtonPrimary>
                                            </td>
                                        ) : null}
                                    </tr>
                                ))
                            ))}
                        </tbody>
                    </Table>
                </div>
            )}
        </div>
    );
};

export default PesquisaEndereco;
